import React from "react";
import {Box, Container, CssBaseline} from "@mui/material";

const PageWrapper = ({mt ,children}) => (
    <div>
        <CssBaseline/>
        <Container maxWidth="lg" sx={{mt: mt ? mt : '6rem'}}>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
            }}>
                {children}
            </Box>
        </Container>
    </div>
);

export default PageWrapper;
